import axios from "axios";

/**
 * GET /payments/saved-methods
 * List saved payment methods (org + current user's personal).
 */
export const getSavedPaymentMethods = async () => {
  try {
    const res: any = await axios.get(`/payments/saved-methods`);
    return res?.data ? res.data : [];
  } catch (e: any) {
    return [];
  }
};

/**
 * POST /payments/setup-intent
 * Create a Stripe SetupIntent for saving a card without charging.
 */
export const createSetupIntent = async () => {
  try {
    const res: any = await axios.post(`/payments/setup-intent`);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

/**
 * POST /payments/save-card
 * Save a card after SetupIntent confirmation.
 */
export const saveCard = async (data: {
  setupIntentId: string;
  label?: string;
  ownerType?: "org" | "user";
}) => {
  try {
    const res: any = await axios.post(`/payments/save-card`, data);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

/**
 * POST /payments/save-card-from-payment
 * Save a card from a completed PaymentIntent (checkbox on payment modal).
 */
export const saveCardFromPayment = async (data: {
  paymentIntentId: string;
  label?: string;
  ownerType?: "org" | "user";
}) => {
  try {
    const res: any = await axios.post(`/payments/save-card-from-payment`, data);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

/**
 * POST /payments/save-bank-account
 * Save a bank account from Plaid for reuse.
 */
export const saveBankAccount = async (data: {
  publicToken: string;
  accountId: string;
  label?: string;
  ownerType?: "org" | "user";
}) => {
  try {
    const res: any = await axios.post(`/payments/save-bank-account`, data);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

/**
 * POST /payments/save-bank-account-from-payment
 * Save a bank account that's already attached from a completed ACH payment.
 * No Plaid token re-exchange needed.
 */
export const saveBankAccountFromPayment = async (data: {
  bankAccountId: string;
  label?: string;
  ownerType?: "org" | "user";
}) => {
  try {
    const res: any = await axios.post(`/payments/save-bank-account-from-payment`, data);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

/**
 * POST /payments/charge-saved-method
 * Pay an invoice with a previously saved payment method.
 */
export const chargeSavedMethod = async (data: {
  paymentMethodRecordId: string;
  invoiceId: string;
  invoiceSequence: number;
  value: number;
  fees: number;
  payer: { id: string };
  type: string;
  paymentMethod?: string;
  transactionDate: string;
  paymentPlan?: string;
}) => {
  try {
    const res: any = await axios.post(`/payments/charge-saved-method`, data);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

/**
 * DELETE /payments/saved-methods/:id
 * Remove a saved payment method.
 */
export const removeSavedMethod = async (id: string) => {
  try {
    const res: any = await axios.delete(`/payments/saved-methods/${id}`);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};
